export default "__VITE_ASSET__BZuDC8nF__"